<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2" [testHook]="testHooks.Link"
		><h4>Fire Insurance</h4></app-anchor
	>
	<h4 class="flex-1">/ Edit Fire insurance Brokerage</h4>
</div>
<app-container type="dark" class="mt-2" [testHook]="testHooks.Container">
	<div>
		<app-create-company-side-form
			[minify]="false"
			(onSubmit)="_onSubmit($event)"
			(onCancel)="_onCancel()"
			[name]="fireInsuranceBrokerage?.name"
			[company]="fireInsuranceBrokerage"
		>
		</app-create-company-side-form>
	</div>
</app-container>
